import React from "react";
import "./card.scss";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const Dropdown = ({ onChange, form, selectedForms }) => {
  // const [form, setForm] = useState("TT Check Socket");

  return (
    <div>
      <div className="formDropdonw">
        <Box sx={{ minWidth: 548 }}>
          <InputLabel>Choose second order form</InputLabel>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={form}
              onChange={onChange}
            >
              <MenuItem value="2">Select any order form</MenuItem>
              <MenuItem value="3">TT Check Socket</MenuItem>
              <MenuItem value="4">TF Check Socket</MenuItem>
              <MenuItem value="5">TT Definitive Socket</MenuItem>
              <MenuItem value="6">TF Definitive Socket</MenuItem>
              <MenuItem value="7">TT One® Socket</MenuItem>
              <MenuItem value="8">TF One® Socket</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </div>
    </div>
  );
};

export default Dropdown;
